'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBotResponder = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBotResponder = exports.getBotResponder = (0, _getIn2.default)(['botResponder']);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/widget-data/getBotResponder.js
// module id = 258
// module chunks = 2 3